import { QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_LOADER_PROGRESS, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_UPLOADER_PROGRESS, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_FAILURE, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_LOADING, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_STATUS_RESET, QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_SUCCESS } from "./app.types";

export const init_app_state = {
  output: {
    status: {
      loading: false,
      success: false,
      failure: false,
      error_message: null,
      download_progress: {
        estimated: null,
        total: null,
        loaded: null,
        progress: 0
      },
      upload_progress: {
        progress: 0
      },
    },
    machine_view: null,
    product_view: null,
    analyst_view: null,
    sla_metrics: null
  },
};

export const app_reducer = (state = init_app_state, action) => {
  const { type, payload } = action;
  switch (type) {
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_LOADING: {
      return {
        ...state,
        output: {
          ...state.output,
          status: {
            loading: true,
            success: false,
            failure: false,
            error_message: null,
            download_progress: {
              estimated: null,
              total: null,
              loaded: null,
              progress: 0
            },
            upload_progress: {
              progress: 0
            },
          }
        }
      };
    }
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_SUCCESS: {
      // const { machine_view, analyst_view, product_view, sla_metrics } = payload;
      return {
        ...state,
        output: {
          ...state.output,
          ...payload,
          status: {
            loading: false,
            success: true,
            failure: false,
            error_message: null,
            download_progress: {
              estimated: null,
              total: null,
              loaded: null,
              progress: 0
            },
            upload_progress: {
              progress: 0
            },
          }
        }
      };
    }
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_FAILURE: {
      // const { machine_view, analyst_view, product_view, sla_metrics } = payload;
      return {
        ...state,
        output: {
          ...state.output,
          ...payload,
          status: {
            loading: false,
            success: false,
            failure: true,
            error_message: payload,
            download_progress: {
              estimated: null,
              total: null,
              loaded: null,
              progress: 0
            },
            upload_progress: {
              progress: 0
            },
          }
        }
      };
    }
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_STATUS_RESET: {
      // const { machine_view, analyst_view, product_view, sla_metrics } = payload;
      return {
        ...state,
        output: {
          ...state.output,
          ...payload,
          status: {
            loading: false,
            success: false,
            failure: false,
            error_message: null,
            download_progress: {
              estimated: null,
              total: null,
              loaded: null,
              progress: 0
            },
            upload_progress: {
              progress: 0
            },
          }
        }
      };
    }
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_LOADER_PROGRESS:
      return {
        ...state,
        output: {
          ...state.output,
          status: {
            ...state.output.status,
            download_progress: payload
          }
        }
      };
    case QC_SCHEDULER_GENERATE_SCHEDULE_ACTION_DATA_UPLOADER_PROGRESS:
      console.log({ payload });
      return {
        ...state,
        output: {
          ...state.output,
          status: {
            ...state.output.status,
            upload_progress: {
              ...state.output.status.upload_progress,
              progress: payload
            }
          }
        }
      };

    default:
      return state;
  }
};